import axios from "axios";

const baseUrl = 'https://kaupunkisuunnistus-backend.vercel.app/api/events'

const getAll = () => {
  const request = axios.get(baseUrl);
  return request.then(response => response.data);
};

const create = newObject => {
  const userStr = window.localStorage.getItem('token')
    const user = JSON.parse(userStr)
    
    const token = user.token
    const config ={
      headers: {Authorization: token}
    }
  const request = axios.post(baseUrl, newObject,config)
  return request.then(response => response.data)
}

const removeAll = () => {
  const userStr = window.localStorage.getItem('token')
    const user = JSON.parse(userStr)
    
    const token = user.token
    const config ={
      headers: {Authorization: token}
    }
  const request = axios.delete(baseUrl,config)
  return request.then(response => response.data)
}

// eslint-disable-next-line
export default { getAll, create, removeAll };
